import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'small' | 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  const cardClasses = {
    small: 'w-[160px]',
    normal: 'w-[200px]',
    large: 'w-[240px]',
  };

  const imgHeight = {
    small: 'h-[224px]',
    normal: 'h-[280px]',
    large: 'h-[336px]',
  };

  return (
    <Link
      to={`/article/${movie.id}`}
      className={`${cardClasses[size]} group cursor-pointer shrink-0`}
    >
      <div className={`${imgHeight[size]} relative rounded-lg overflow-hidden bg-background-200`}>
        <img
          src={movie.poster}
          alt={movie.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {movie.isVip && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-950 text-xs font-semibold rounded-md">
            VIP
          </span>
        )}
        {movie.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-semibold rounded-md">
            新
          </span>
        )}
        {movie.isHot && !movie.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-semibold rounded-md">
            热
          </span>
        )}

        <div className="absolute bottom-2 left-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="text-xs text-white/90 bg-black/50 px-2 py-0.5 rounded-full">
            {movie.scoreLabel || `⭐ ${movie.rating > 0 ? movie.rating : '即将上映'}`}
          </span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          {movie.rating > 0 && (
            <span className="text-xs text-accent-500 font-semibold">{movie.rating}</span>
          )}
          <span className="text-xs text-foreground-500">{movie.episodeInfo}</span>
        </div>
      </div>
    </Link>
  );
}